import * as utils from "../../utils/utils.js";

export default function () {
  const widgetName = "yyBannerWidget";
  const widgetOpts = yyBannerWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    hasImages: true,
    showDescription: true,
    buyNowButton: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    link: [""],
    moreButton: {
      visible: true,
      text: "Learn More",
    },
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(".tier-3-container").remove();
      } else {
        createCustomYYBanner(data.items);
      }
    },
  });

  function createCustomYYBanner(widgetData) {
    $(`#${widgetName}`)
      .find(".moreButton")
      .addClass("button")
      .removeClass("moreButton");
    $(`#${widgetName} .card-widget-item`).each(function (x) {
      const { URL } = widgetData[x];
      const $cardBanner = $(this);
      const targetElement = !utils.isLocalUrl(URL) ? "target='_blank'" : "";

      $cardBanner.find(".button").attr(targetElement);
    });
  }
}
